import { LanguageCode } from "@models/enums/App/Languages.enum";
import { SelectorType } from "@models/types/components/VenueConfigurations.type";
import { ThemeMode } from "@models/enums/App/ThemeMode.enum";
import { ButtonColors } from "@models/enums/components/Button/ButtonColor.enum";
import { SearchTypes } from "@models/enums/components/Search/SearchTypes.enum";
import { DisplayType } from "@models/interfaces/components/Menu.interface";
import { Configuration } from "@models/interfaces/configuration/index.interface";

export const defaultBranding = {
  logo: '/assets/img/3ddv/logo.png',
  favicon: '/assets/img/3ddv/favicon.png',
  color_main: '#0089F7',
  color_secondary: '#FFFFFF',
  color_vip: '#CBA57F'
};

export const DefaultConfig: Configuration = {

    General: {
        title:                  "",
        client: {
            name:               "",
            logo:               defaultBranding.logo,
            favicon:            defaultBranding.favicon
        },
        texts: {
            top:                "VENUE NAME",
            main:               "CONFIG NAME",
            bottom:             "SEASON 2025/26 (optional)",
        },
        theme: {
            color_main:         defaultBranding.color_main,
            color_secondary:    defaultBranding.color_secondary,
            color_vip:          defaultBranding.color_vip,
            mode:               ThemeMode.Dark,
        },
        debugger:               false
    },

    Dvm: {
        viewer: {
            venueId:            "",
            mapId:              "",
            is3d:               false,
            isMultilevel:       false,
            forceMainView:      false,
            viewId:             "",
            styles:             {}
        },
        minimap: {
            enabled:            true,
            position:           "Bottom",
            mapId:              "",
            navigableMinimapEnabled: false
        },
        misc: {
            version:            "",
            plugins: {
                viewerPlugins:      undefined,
                viewer3dPlugins:    undefined
            },
            flags: {
                viewerFlags:        undefined,
                viewer3dFlags:      undefined
            }
        }
    },

    Ui: {
        Search: {
            hasSearch:        true,
            fileData:         {},
            type:             SearchTypes.Simple,
            order:            'alphabetical'
        },
        Menus: {
            clientId:      "",
            type:          DisplayType.Simple,
            isLegend:      false,
            menus:         {
                regular: {
                  id: "regular",
                  label: "Regular",
                  order: 1,
                  isVisible: true,
                  buttonType: ButtonColors.Default,
                  content: []
                },
                premium: {
                  id: "premium",
                  label: "Premium",
                  order: 2,
                  isVisible: true,
                  buttonType: ButtonColors.Vip,
                  content: []
                },
                suites:  {
                  id: "suites",
                  label: "Suites",
                  order: 3,
                  isVisible: true,
                  buttonType: ButtonColors.Vip,
                  content: []
                }
            }
        },
        LinkActionButtons: [],
        ActionButtons: [],
        Neighbors: {
            enabled:          false,
            modeLr:           false,
            data:             {}
        },
        GeneralAdmission: {
            enabled:          false,
            data:             [],
        },
        Disclaimer: {
            enabled:          false,
            data:             {},
            allNodes: {
                enabled:      false,
                all3dViews:   false,
                allSeatmaps:  false,
                text:         ''
            }
        },
        MapButtons: {
            panning:          true,
            zoom:             true
        },
        Translation: {
            enabled:          false,
            data:             {}
        },
        SeatmapDisplay: {
            enabled:          true,
            bestNode:         false
        },
        View3dDisplay: {
            enabled:          true,
            viewVersion:      '',
            fullscreen:       true,
            copySeatLink:     true
        },
        SeatLevelDisplay: {
            enabled:          false
        },
        CustomPopups: {
            enabled:          false,
            data: {
                sections: {},
                rows:     {},
                seats:    {}
            }
        },
        RandomAvailability: {
            enabled: false,
            applyTo: [],
            percentages: {},
        },

        CustomAvailability: {
            enabled: false,
            data: {}
        },
        Languages: {
            defaultLang: LanguageCode.EN
        },

        // `data` debe quedarse en [] siempre (lodash `merge` fusiona arrays por indice, nunca
        // los encoge). Bloque identico al de `ConfigurationValues`.
        VenueConfigurations: {
            enabled: false,
            main: {
                selectorType: SelectorType.Icon,
                icon:  '',
                label: ''
            },
            data: []
        }
    }

};